import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAddressDialogShippingContent = loadable(
  () => import(/* webpackChunkName: "registry/address-dialog-shipping-content" */ './AddressDialogShippingContent'),
  'AddressDialogShippingContent',
);
